import genericApi from './genericApi';

import ApiResponse from '../models/ApiResponse';
import ForwarderAccountTable from '../models/ForwarderAccountTable';
import GhaFwdConfig from '../models/GhaFwdConfig';

const ghaFwdConfigReqHandler = {

  getGhaFwdConfig: (id: number): Promise<ApiResponse<GhaFwdConfig>> => {
    return genericApi.get(`gha_fwd_config/${id}`)
  },

  createGhaFwdConfig: (fwdId: number) : Promise<ApiResponse<boolean>> => {
    return genericApi.post(`gha_fwd_config/${fwdId}`);
  },

  getForwarderInvoiceAccounts: (): Promise<ApiResponse<Array<ForwarderAccountTable>>> => {
    return genericApi.get('gha_fwd_config_amount')
  },

  updateGhaFwdConfig: (fwdId: number, data: GhaFwdConfig): Promise<ApiResponse<boolean>> => {
    return genericApi.put(`gha_fwd_config/${fwdId}`,{config: data})
  }  
};

export default ghaFwdConfigReqHandler;